import { getAccessToken } from 'cng-common/helpers/access'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { mapContactFlagFromContactFlagsAllData } from './mapping'

export const fetchContactFlagsByIds = async (ids: string[] = [], topPartnerId: string) => {
  const url = proxy(`/webservice/197/sp/v4/spGetContactFlagsData/call`)
  const accessToken = getAccessToken()
  const payload = {
    'p.ContactIds': ids.join(','),
    'p.TopPartnerId': topPartnerId,
  }

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Data.map(mapContactFlagFromContactFlagsAllData)
  } catch (e) {
    Logger.error(e)
    return []
  }
}
